import React from 'react'

import { bemJoin } from 'bem-join'

import { IntlMessageKeys, useIntl } from '@app/intl/Intl'
import { InputField } from '@app/lib/fields/InputField/InputField'
import { Select } from '@app/lib/inputs/Select'

export const InvoicingEndgameSelect = () => {
  const b = bemJoin('court-case-invoicing-form')
  const { formatMessage } = useIntl()

  const options = [
    'PlaintiffGivesUp.Before',
    'PlaintiffGivesUp.After',
    'DefendantWithdraws.Before',
    'DefendantWithdraws.After',
    'Settlement.BeforeHearing',
    'Settlement.AtHearing',
    'Settlement.AfterHearing',
    'Judgment.DeadlineExpired',
    'Judgment.LegallyBinding'
  ]

  return (
    <InputField
      name='Endgame'
      className={b('field', { lg: true })}
      label={formatMessage({ id: 'CourtCases.Invoicing.Field.Endgame' })}
      rules={{
        required: {
          value: true,
          message: formatMessage({ id: 'CourtCaseDialog.Popup.Select.Required' })
        }
      }}
      render={({ inputProps, error }) => {
        return (
          <Select
            {...inputProps}
            triggerSize='sm'
            error={error}
            placeholder={formatMessage({
              id: 'CourtCases.Invoicing.Field.Endgame.Placeholder'
            })}
            options={options.map((value) => ({
              value,
              label: formatMessage({
                id: `CourtCases.Invoicing.Option.Endgame.${value}` as IntlMessageKeys
              })
            }))}
          />
        )
      }}
    />
  )
}
